import {Component, EventEmitter, Inject, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {base64ToFile, Dimensions, ImageCroppedEvent, ImageCropperComponent, ImageTransform} from 'ngx-image-cropper';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

import {CompressImageService} from '../../../core/utils/compress-image.service';

@Component({
  selector: 'app-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.css']
})
export class ImageEditorComponent implements OnInit {
  // @ts-ignore
  @ViewChild(ImageCropperComponent) imageCropper: ImageCropperComponent;
  imageChangedEvent: any = '';
  imageFile: any = '';
  imageURL: any = '';
  loadedImage: any = '';
  imageToSave: any = '';
  croppedImage: any = '';
  canvasRotation = 0;
  rotation = 0;
  scale = 1;
  showCropper = false;
  containWithinAspectRatio = false;
  transform: ImageTransform = {};
  slideValue = 0;
  maxZoom = 25;
  minZoom = 0;
  aspectRatio = 300 / 160;
  roundCropper = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ImageCropperComponent>,
    private compressImage: CompressImageService
  ) {}

  ngOnInit(): void {
    if (this.data.avatar) {
      this.aspectRatio = 1;
    }

    if (this.data.imageURL) {
      this.imageURL = this.loadedImage = this.data.imageURL;
      this.showCropper = true;
    }
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = this.loadedImage = event;
  }

  fileDropEvent(event: any): void {
    this.imageFile = this.loadedImage = event[0];
  }

  crop(event: ImageCroppedEvent) {
    console.log(event);
    this.compressImage.compress(base64ToFile(event.base64)).subscribe( compressData => {
      this.croppedImage = compressData;
    });
  }

  saveImage() {
    this.dialogRef.close({file: this.imageToSave} );
  }

  resetCroppedImag() {
    this.croppedImage = '';
    this.imageFile = this.loadedImage;
  }

  close() {
    this.dialogRef.close({file: null});
  }

  imageLoaded() {
    this.showCropper = true;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    this.showCropper = false;
    this.compressImage.compress(base64ToFile(event.base64)).subscribe( compressData => {
      this.imageToSave = compressData;
    });
  }

  cropperReady(sourceImageDimensions: Dimensions) {
  }

  loadImageFailed() {
    console.log('Load failed');
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  zoomOut() {
    if (this.slideValue === this.minZoom) {
      return;
    }
    this.scale -= .1;
    this.slideValue--;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    if (this.slideValue === this.maxZoom) {
      return;
    }
    this.scale += .1;
    this.slideValue++;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  onSlideMove(event) {
    if (this.slideValue < event.value) {
      this.zoomIn();
    } else {
      this.zoomOut();
    }
  }

  resetImage() {
    this.croppedImage = '';
    this.showCropper = true;
  }
}
